<template>
    <notification-behavioral ref="notificationBase" class="notification-pricing-noted" :item="item"
                             :behaviors="behaviors"
                             @behaviorCompleted:note="handleNoteSent"
    >
        <template slot="title" :item="item">
            <div class="" style="flex:1">({{item.customerId}}) {{item.customerName}} - {{item.title}} <a :href="'/partner/customer/index/id/' + item.customerId"><span class="glyphicon glyphicon-globe"></span></a></div>
        </template>

        <div slot="body">
            <div v-for="n in item.notes" class="" style="">
                <div>{{n.createdBy}} @ {{n.createdAt}}</div>
                <div>
                    <pre>{{n.note}}</pre>
                </div>
            </div>
        </div>

        <div slot="behaviors"></div>
    </notification-behavioral>
</template>

<script>
    import NotificationBehavioral from '@/components/notifications/behaviors/Behavioral'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        name: 'NotificationPricingNoted',
        data () {
            return {
                behaviors: [
                    {
                        name: 'note',
                        label: '',
                        description: 'Reply',
                        icon: 'glyphicon-comment',
                        requestAction: () => {
                            return '/partner/customer-opportunity/load-note/opportunityid/' + this.item.objectId
                        },
                        requestMethod: 'post'
                    }
                ]
            }
        },
        computed: {
        },
        methods: {
            handleNoteSent: function (data) {
                this.$refs.notificationBase.showBehaviorMessage(data.message, 'success')
            }
        },
        components: {
            NotificationBehavioral
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// PricingNoted.vue?75e51821